import { useEffect } from 'react';
import { appSettings } from 'appSettings';
import { useLocation  } from "react-router-dom";
import constants from 'constants.json';

export const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        const gaScriptElement = document.getElementById("ga-script");
        if (!gaScriptElement) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${appSettings.GoogleAnalytics.MeasurementId}`;
            script.id = "ga-script";
            document.head.appendChild(script);
        }

        const windowUntyped = (window as any);
        windowUntyped.dataLayer = windowUntyped.dataLayer || [];
        function gtag(...args: any[]) { windowUntyped.dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', appSettings.GoogleAnalytics.MeasurementId, { 'send_page_view': false });
    }, []);

    useEffect(()=>{
        gaPageView(location.pathname + location.search);
        //console.debug(`GoogleAnalytics: location = `, location);
        // gtag("event", "page_view", {
        //     page_title: document.title.startsWith(constants.PageTitlePrefix) ? document.title.replace(constants.PageTitlePrefix, "") : document.title,
        //     page_path: location.pathname + location.search,
        //     send_to: appSettings.GoogleAnalytics.MeasurementId,
        //     event_callback: (a: unknown, b: unknown) => {
        //         //console.debug(`GoogleAnalytics: event sent... a = `, a, `, b = `, b)
        //     }
        // });
    }, [location]);

    return null;
}


export const gaPageView = (path: string) => {
    const windowUntyped = (window as any);
    windowUntyped.dataLayer = windowUntyped.dataLayer || [];
    function gtag(...args: any[]) { windowUntyped.dataLayer.push(arguments); }
    gtag("event", "page_view", {
        page_path: path,
        page_title: document.title.startsWith(constants.PageTitlePrefix) ? document.title.replace(constants.PageTitlePrefix, "") : document.title,
        send_to: appSettings.GoogleAnalytics.MeasurementId,
        event_callback: () => {
            //console.debug(`GoogleAnalytics: event sent...`)
        }
    });
}

export const gaEvent = (action: string, category?: string, label?: string, value?: string) => {
    const windowUntyped = (window as any);
    windowUntyped.dataLayer = windowUntyped.dataLayer || [];
    function gtag(...args: any[]) { windowUntyped.dataLayer.push(arguments); }
    gtag("event", action, {
        'event_category': category,
        'event_label': label,
        'value': value,
        event_callback: () => {
            //console.debug(`GoogleAnalytics: event sent...`)
        }
    });
}